<template>
    <div class="parentListTable">
        <table>
            <tbody>
            <tr class="title">
                <th>交流主题</th>
                <th>交流次数</th>
                <th>咨询时间</th>
                <th>操作</th>
            </tr>
            <tr  v-for="(value,index) in list" :key="index" >
                <td class="type">
                    {{value.interviewTheme}}
                </td>
                <td>第{{value.interviewNum}}次咨询</td>
                <td>{{value.interviewTime}}</td>
                <td>
                    <span
                        class="btn goView"  @click="goDetail(value.id,value.category)"
                    >查看</span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    name: "parentListTable",
    props: ['list','userType','studentId'],
    components: {
    },
    data() {
        return {
        }
    },
    computed: {
        path() {
            if(this.userType==1) {
               return '/studyPlan/consultationRecord/parent/detail'

            }else if(this.userType==2) {
                return '/parent/main/consultationRecord/parent/detail'
            }else if(this.userType==3) {
                return '/consultant/minestudent/main/consultationRecord/parent/detail'
            }
        }
    },
    methods: {
        goDetail(id,category) {
            let path = this.path;
            if(this.userType==3) {
                if(category==1){
                    this.$router.push({path:'/consultant/newstudent/main/firstInterviewPartA',query:{studentId: this.studentId,show:'已完成'}})
                    return;
                }
                this.$router.push({path:path,query:{id: id}})
            }else if (this.userType==2){
              if(category==1){
                this.$router.push({path:'/parent/main/studentMessage/parent'})
                return;
              }
                this.$router.push({path:path,query:{id: id}})
            }else if (this.userType==1){
              if(category==1){
                this.$router.push({path:'/studyPlan/studentMessage/parent'})
                return;
              }
                this.$router.push({path:path,query:{id: id}})
            }
        }
    }

}
</script>

<style scoped lang="less">
.parentListTable {
    table {
        width: 100%;
        th {
            text-align: center;
        }
        tr.title {
            background: rgba(61, 144, 246, 0.2);
            border-radius: 5px;
            font-size: 16px;
            font-weight: bold;
            color: #333;
        }
        tr {
            line-height: 40px;
            text-align: center;
            border-bottom: 1px solid #ECECEC !important;
            .goView {
                color: #0095EB;
                cursor: pointer;
            }
            th {
                font-weight: bold;
            }
        }
        .type {
            display: flex;
            align-items: center;
            justify-content: center;
            span {
                width: 10px;
                height: 10px;
                border-radius: 50%;
                margin-right: 5px;
            }
        }
    }
}
</style>